import React, { Fragment, useState } from 'react'
import useRootStore from '@store/useRootStore'
import { useOnMount, useOnUnmount } from '@utils/reactExt'
import { observer } from 'mobx-react'
import { isMobile } from 'react-device-detect'
import { message } from 'antd'
// icon
import { GmoneyIco } from '@shared/Icon/MoneyIcon'
// img
import bettingHistoryImg from '@assets/images/guide/guide-betting-history.jpg'
import bettingMethodImg from '@assets/images/guide/guide-betting-method.jpg'
import matchSelect from '@assets/images/guide/guide-match-select.jpg'
import purchaseGmoney from '@assets/images/guide/guide-purchase-gmoney.jpg'
// eslint-disable-next-line import/extensions
import LoadingImg from '@assets/images/gif/guide-loading.gif'
// css
import {
  ContentWrap,
  Content,
} from '@styles/base.style'
import { Button } from '@styles/button.style'
import { GlobalStoreKey } from '@v2/constants/common'
import { GuideWrap, GuideNavWrap, GuideNavBtn, CountAniWrap } from '../index.style'

const Index: React.FC = props => {
  const { authStore, routerStore, globalStore, userStore } = useRootStore()
  const { getGuideBonusEnabled } = globalStore
  const visibleGuideBonusReceiveButton = authStore.isSignedIn && globalStore.visibleGuideBonusReceiveButton
  const visibleGuideBonusDelay = visibleGuideBonusReceiveButton && globalStore.visibleGuideBonusDelay
  const guideRewardTotalDelayTime = Number(globalStore.findGlobalSetting(GlobalStoreKey.GUIDE_BONUS_DELAY_TIME)?.value)
  const [currentGuideRewardDelayTime, setCurrentGuideRewardDelayTime] = useState(
    visibleGuideBonusDelay ? guideRewardTotalDelayTime : 0
  )

  const isEnabledGuideBonus = getGuideBonusEnabled()

  let rewardDelayTimer

  useOnUnmount(() => {
    clearInterval(rewardDelayTimer)

    window.removeEventListener('scroll', scrollChangeHandler, true)
  })

  useOnMount(() => {
    if (rewardDelayTimer) {
      clearInterval(rewardDelayTimer)
    }

    if (!authStore.isSignedIn) {
      routerStore.push('/')
    }

    if (visibleGuideBonusDelay) {
      let deltaTime = currentGuideRewardDelayTime - 1
      rewardDelayTimer = setInterval(() => {
        if (deltaTime <= 0) {
          globalStore.setVisibleGuideBonusDelay(false)
          clearInterval(rewardDelayTimer)
        }
        deltaTime -= 1
        setCurrentGuideRewardDelayTime(deltaTime)
      }, 1000)
    }

    window.addEventListener('scroll', scrollChangeHandler, true)
  })

  const onClickGuideBonusReceive = async () => {
    const response = await userStore.receiveGuideBonus()
    await authStore.refreshSimpleUserInfo(true)
    if (response.result) {
      globalStore.setVisibleGuideCompletePopup(true)
    } else {
      message.info('이미 다른 계정에서 지급 받았습니다.')
    }
  }

  const scrollChangeHandler = () => {
    const liLists = document.querySelectorAll('#guideNav > li > .guide-nav-btn')
    if (liLists.length === 0) {
      return
    }

    const goBettingMethod = document.getElementById('goBettingMethodGuide')
    const goBettingHistory = document.getElementById('goBettingHistoryGuide')
    const goLeagueSelect = document.getElementById('goLeagueSelectGuide')
    const goPurchaseGmoney = document.getElementById('goPurchaseGmoneyGuide')

    const guideSection = document.querySelectorAll('.guide-section')

    const purchaseGmoneyGuideHeight = guideSection[0].scrollHeight
    const bettingMethodGuideHeight = guideSection[1].scrollHeight
    const bettingHistoryGuideHeight = guideSection[2].scrollHeight
    // const matchSelectGuideHeight = guideSection[3].scrollHeight

    let scrollPosition = 0
    if (isMobile) {
      scrollPosition = window.scrollY || document.documentElement.scrollTop
    } else {
      scrollPosition = document.getElementById('guideContentWrap').scrollTop
    }

    for (let i = 0; i < liLists.length; i += 1) {
      liLists[i].className = liLists[i].className.replace(' active', '')
    }
    if (scrollPosition < purchaseGmoneyGuideHeight) {
      goPurchaseGmoney.classList.add('active')
    } else if (scrollPosition < (purchaseGmoneyGuideHeight + bettingMethodGuideHeight)) {
      goBettingMethod.classList.add('active')
    } else if (scrollPosition < (purchaseGmoneyGuideHeight + bettingMethodGuideHeight + bettingHistoryGuideHeight)) {
      goBettingHistory.classList.add('active')
    } else if (scrollPosition > (purchaseGmoneyGuideHeight + bettingMethodGuideHeight + bettingHistoryGuideHeight)) {
      goLeagueSelect.classList.add('active')
    }
  }

  const move = (e) => {
    let location
    switch (e.currentTarget.id) {
      case 'goPurchaseGmoneyGuide':
        location = document.getElementById('purchaseGmoney')
        break
      case 'goBettingMethodGuide':
        location = document.getElementById('bettingMethod')
        break
      case 'goBettingHistoryGuide':
        location = document.getElementById('bettingHistory')
        break
      case 'goLeagueSelectGuide':
        location = document.getElementById('matchSelect')
        break
      default:
        break
    }
    location.scrollIntoView({ behavior: 'smooth', block: 'start' })
  }

  let contentWarpStyle
  if (!isMobile) {
    contentWarpStyle = { overflow: 'auto', height: 'calc(100% - 142px)', background: 'none' }
  }

  const renderGuideBonusButton = (
    <CountAniWrap className={`count-ani-wrap ${visibleGuideBonusReceiveButton ? '' : 'adv-hidden'}`}>
      {/* ************ 15초 카운트 ************ */}
      <div className={`gauge ${visibleGuideBonusDelay ? '' : 'adv-hidden'}`} style={{ animationDelay: `${guideRewardTotalDelayTime}s` }}>
        <div className="gauge--bar">
                <span className="gauge--bar--fill" style={{ animationDuration: `${guideRewardTotalDelayTime}s` }}>
                  <img src={LoadingImg} alt="달리는 축구 선수" className="gauge--bar--fill--gif"/>
                </span>
        </div>
        <div className="gauge--count">
          <span className="gauge--count--num">{currentGuideRewardDelayTime}</span>
          <span className="gauge--count--txt">초 후 가이드 정독 보상을 받을 수 있습니다.</span>
        </div>
      </div>
      {/* *************************************************** */}

      {/* 버튼 숨김처리는 className: adv-hidden를 추가하시면 됩니다. */}
      <Button primary className={`guide-btn ${currentGuideRewardDelayTime <= 0 ? '' : 'adv-hidden'}`}
              onClick={onClickGuideBonusReceive}><GmoneyIco/>보상 받기
      </Button>
    </CountAniWrap>
  )

  return (
    <Fragment>
      <GuideNavWrap className="guide-nav-wrap">
        <ul id="guideNav" className="guide-nav">
          <li><GuideNavBtn id="goPurchaseGmoneyGuide" className="guide-nav-btn cursor-pointer active" onClick={move}>재화 및 구매</GuideNavBtn></li>
          <li><GuideNavBtn id="goBettingMethodGuide" className="guide-nav-btn cursor-pointer" onClick={move}>베팅 방법</GuideNavBtn></li>
          <li><GuideNavBtn id="goBettingHistoryGuide" className="guide-nav-btn cursor-pointer" onClick={move}>베팅 내역</GuideNavBtn></li>
          <li><GuideNavBtn id="goLeagueSelectGuide" className="guide-nav-btn cursor-pointer" onClick={move}>경기 선택</GuideNavBtn></li>
        </ul>
      </GuideNavWrap>

      <ContentWrap style={contentWarpStyle} className="no-padding" id="guideContentWrap">
        <Content>
          <GuideWrap className="guide-wrap">

            <div className="guide-section">
              <img src={purchaseGmoney} alt="G머니 구매 가이드 이미지" style={{ width: '100%' }} className={!isMobile && 'pc-img'}/>
              <span id="purchaseGmoney" className="guide-section--target"/>
            </div>
            <div className="guide-section">
              <img src={bettingMethodImg} alt="베팅 방법 가이드 이미지" style={{ width: '100%' }} className={!isMobile && 'pc-img'}/>
              <span id="bettingMethod" className="guide-section--target"/>
            </div>
            <div className="guide-section">
              <img src={bettingHistoryImg} alt="베팅 내역 가이드 이미지" style={{ width: '100%' }} className={!isMobile && 'pc-img'}/>
              <span id="bettingHistory" className="guide-section--target"/>
            </div>
            <div className="guide-section">
              <img src={matchSelect} alt="리그 선택 가이드 이미지" style={{ width: '100%' }} className={!isMobile && 'pc-img'}/>
              <span id="matchSelect" className="guide-section--target"/>
            </div>

          </GuideWrap>

          {isEnabledGuideBonus && renderGuideBonusButton}

        </Content>
      </ContentWrap>
    </Fragment>
  )
}

export default observer(Index)
